import { create } from 'zustand';

type AdminUser = {
  id: string;
  email: string;
  role: 'admin' | 'resident' | 'guest';
};

type AuthState = {
  accessToken: string | null;
  user: AdminUser | null;
  setAuth: (payload: { accessToken: string; refreshToken: string; user: AdminUser }) => void;
  logout: () => void;
};

const storedToken = localStorage.getItem('admin_accessToken');
const storedUser = localStorage.getItem('admin_authUser');

export const useAuthStore = create<AuthState>((set) => ({
  accessToken: storedToken,
  user: storedUser ? JSON.parse(storedUser) : null,
  setAuth: ({ accessToken, refreshToken, user }) => {
    localStorage.setItem('admin_accessToken', accessToken);
    localStorage.setItem('admin_refreshToken', refreshToken);
    localStorage.setItem('admin_authUser', JSON.stringify(user));
    set({ accessToken, user });
  },
  logout: () => {
    localStorage.removeItem('admin_accessToken');
    localStorage.removeItem('admin_refreshToken');
    localStorage.removeItem('admin_authUser');
    set({ accessToken: null, user: null });
  }
}));
